import React from 'react';
import { UrlService } from "../../../../core/services/UrlService"
import './hero.scss';
import $ from "jquery";

const Hero: React.FC<any> = () => {
    const moveToSelfTest = () => {
        $("html, body").animate({ scrollTop: $('.self-test__test').position()?.top - 50 || 0 }, 1000);
    };

    const moveToContent = () => {
        $("html, body").animate({ scrollTop: $('.self-test__content-sections').position()?.top - 50 || 0 }, 1000);
    };

    return (
        <section role="img" aria-label="Image Description">
            <div className="self-test__hero">
                <div className="container">
                    <div className="self-test__hero-content-container">
                        <div className="self-test__hero-content-text">
                            <div className="self-test__hero-title">
                                <h1 className="entry-title mb-4"> 您有<span className="important">躁鬱症</span>嗎？</h1>
                            </div>
                            <p>
                                香港人生活壓力大，加上近年新冠肺炎疫情反復，精神健康的議題逐漸得到大家關注。
                                不少人也有聽過抑鬱症，亦常以為躁鬱症是抑鬱症的相反，認為抑鬱是憂愁無力不想做事，而躁鬱就是情緒高漲，但其實並不正確。
                                躁鬱症包含了躁狂及抑鬱的情緒，患者會經歷嚴重的情緒波動，時而極度興奮，時而抑鬱絕望。
                                這些波動通常可維持數月，程度亦超越多數人<sup>1</sup>。
                            </p>
                            <p>
                                躁鬱症比想像常見，每100個人中，就有1個人患上<sup>1</sup>。
                                這病絕對不容忽視，病情變得很嚴重時，患者甚至有機會出現思覺失調等徵狀<sup>1</sup>。
                                及早了解病情，積極治療，才能有效控制病情。
                            </p>
                            <div className="self-test__hero-button-container">
                                <button className="self-test__button primary" onClick={moveToSelfTest}>
                                    開始評估
                                </button>
                                <button className="self-test__button secondary" onClick={moveToContent}>
                                    了解更多躁鬱症
                                </button>
                            </div>
                        </div>
                        <div className="img-container">
                            <img src={UrlService.getLocalImageUrl('self-test/bipolar-disease/hero.png')} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;